import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/** The icons of the test mail page, in one place: PageService takes them from here. */
class EmailTestIconsClass {
    public readonly EmailTest: IconType = Icons.MailCheck;
    public readonly Send: IconType = Icons.Send;
}

export const EmailTestIcons = new EmailTestIconsClass();
